import { useTranslation } from "react-i18next";
import LoginModal from "../Component/loginModal";
import { useState } from "react";
import { docId } from "../Utils/constants";
import DoctorChatDashboard from "../Component/Dynamic/DocPortal";

function AdminLogin() {
  const { t, i18n } = useTranslation();
  const [showLoginModal, setShowLoginModal] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const docChatlink = `/docchat?docid=${docId}`;
  return (
    <>
      <h2 className="text-center">Doctor's Dashboard</h2>

      <LoginModal
        showThis={showLoginModal}
        getPass={(pass) => {
          if (pass.toLowerCase() === "aly") {
            setIsAdmin(true);
            setShowLoginModal(false);
          }
        }}
      />
      {isAdmin && <DoctorChatDashboard />}
    </>
  );
}

export default AdminLogin;
